export enum ProcedureControlCodes {
  BASIC_INFO = 'procedure_basic_info',
  OVERVIEW = 'procedure_overview',
  ARTICLES = 'procedure_article',
  RELATED_TOPICS = 'procedure_related_topics',
  WHAT_NEXT = 'procedure_what_next',
  TAGS = 'procedure_tags',
}
